const CustomControl = (props) => {
	let { children, cx, getStyles, innerRef, innerProps, isFocused } = props;

	const styles = getStyles("control", props);

	return (
		<div
			style={{
				...styles,
				boxShadow: isFocused ? "#EA611C 0px 0px 0px 1px" : undefined,
				borderColor: isFocused ? "#EA611C" : styles.borderColor,
			}}
			className={cx({
				control: true,
			})}
			ref={innerRef}
			{...innerProps}
		>
			{children}
		</div>
	);
};

export { CustomControl };
